const cadastro_de_regra_para_valor_absoluto = {
  path: "/cadastro-de-regra-para-valor-absoluto",
  redirect: "/cadastro-de-regra-para-valor-absoluto",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/cadastro-de-regra-para-valor-absoluto",
      name: "cadastro-de-regra-para-valor-absoluto",
      meta: {
        allowedPermissions: [
          "valor_absoluto_listar",
          "valor_absoluto_buscar",
          "valor_absoluto_excluir",
        ],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeRegraParaValorAbsoluto/CadastroDeRegraParaValorAbsolutoHome.vue"
        ),
    },
    {
      path: "/cadastro-de-regra-para-valor-absoluto-novo",
      name: "cadastro-de-regra-para-valor-absoluto-novo",
      meta: {
        allowedPermissions: ["valor_absoluto_criar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeRegraParaValorAbsoluto/CadastroDeRegraParaValorAbsolutoCreate.vue"
        ),
    },
    {
      path: "/cadastro-de-regra-para-valor-absoluto-editar/:id",
      name: "cadastro-de-regra-para-valor-absoluto-editar",
      meta: {
        allowedPermissions: ["valor_absoluto_atualizar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeRegraParaValorAbsoluto/CadastroDeRegraParaValorAbsolutoUpdate.vue"
        ),
    },
  ],
};

export { cadastro_de_regra_para_valor_absoluto };
